import { useMemo } from "react";
import { OrderProduct, Product } from "shared/api/middleware-api-client";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";
import SelfAssemblyProductItemConfigTable from "./SelfAssemblyProductItemConfigTable";
import SelfAssemblyProductItemPrice from "./SelfAssemblyProductItemPrice";

interface ProductItemSidebarProps {
  product: Product | OrderProduct;
}

const SelfAssemblyProductItemSidebar = ({
  product,
}: ProductItemSidebarProps) => {
  const imageID = useMemo(() => {
    if ("doorLayout" in product) {
      return product.doorLayout.imageId;
    }
    return product.imageId;
  }, [product]);

  const doorTypeName = useMemo(() => {
    if ("doorType" in product) {
      return product.doorType.name;
    }
    return product.doorOption;
  }, [product]);

  return (
    <>
      <div
        className={concatClassnames(
          "gg-col-span-12",
          "gg-grid gg-grid-cols-12",
        )}
      >
        <div
          className={concatClassnames(
            "gg-col-span-12 gg-col-start-2 gg-mb-5 sm:gg-col-span-3 md:gg-col-span-4 lg:gg-col-span-3 xl:gg-col-span-5 2xl:gg-col-span-4",
          )}
        >
          <OptionConfigurationImage
            className="!gg-h-24 !gg-w-24 gg-shrink-0 sm:gg-h-28 sm:gg-w-28 md:!gg-h-40 md:!gg-w-40"
            imageId={imageID}
          />
        </div>

        <div
          className={concatClassnames(
            "gg-col-span-12 gg-col-start-2 gg-mb-5 gg-justify-center sm:gg-col-span-9 md:gg-col-span-6 lg:gg-col-span-7 xl:gg-col-span-7 2xl:gg-col-span-8",
          )}
        >
          <Heading headingLevel="h2" className="gg-mb-3">
            {doorTypeName}
          </Heading>

          <SelfAssemblyProductItemConfigTable product={product} />
        </div>

        <SelfAssemblyProductItemPrice
          className={`gg-col-span-12 gg-col-start-2 gg-items-center gg-gap-x-4 sm:gg-col-start-4 md:gg-col-span-2 lg:gg-col-span-2 xl:gg-col-span-12 xl:gg-col-start-6 2xl:gg-col-start-5 2xl:gg-flex`}
          product={product}
        />
      </div>
    </>
  );
};
export default SelfAssemblyProductItemSidebar;
